var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedRefillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21.5,
    r: 17,
    fill: "#FCE6EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3105,
    y: 8.42334,
    width: 11.5862,
    height: 2.53846,
    fill: "#99DDF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6543,
    y: 2.5,
    width: 14.8965,
    height: 6.76923,
    rx: 1,
    fill: "#4DAADD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2069 33.5004V16.8336C27.2069 16.2 27.0564 15.5755 26.7678 15.0115L25.5052 12.5441C25.3857 12.3106 25.3234 12.0521 25.3234 11.7898C25.3234 11.3326 24.9528 10.9619 24.4955 10.9619H11.7114C11.2541 10.9619 10.8835 11.3326 10.8835 11.7898C10.8835 12.0521 10.8212 12.3106 10.7017 12.5441L9.43912 15.0115C9.1505 15.5755 9 16.2 9 16.8336V33.5004C9 34.6049 9.89543 35.5004 11 35.5004H25.2069C26.3115 35.5004 27.2069 34.6049 27.2069 33.5004Z",
    fill: "#4DAADD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3105,
    y: 22.8076,
    width: 11.5862,
    height: 1.69231,
    rx: 0.846154,
    fill: "#99DDF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9307,
    y: 17.731,
    width: 11.8462,
    height: 1.65517,
    rx: 0.827586,
    transform: "rotate(90 18.9307 17.731)",
    fill: "#99DDF3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3105,
    y: 3.34619,
    width: 0.827587,
    height: 5.07692,
    rx: 0.413794,
    fill: "#276CA4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6211,
    y: 3.34619,
    width: 0.827583,
    height: 5.07692,
    rx: 0.413792,
    fill: "#276CA4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7598,
    y: 3.34619,
    width: 0.827585,
    height: 5.07692,
    rx: 0.413793,
    fill: "#276CA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0684 3.75998C23.0684 3.53145 23.2536 3.34619 23.4822 3.34619C23.7107 3.34619 23.8959 3.53145 23.8959 3.75998V8.00932C23.8959 8.23785 23.7107 8.42311 23.4822 8.42311C23.2536 8.42311 23.0684 8.23785 23.0684 8.00932V3.75998Z",
    fill: "#276CA4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3805,
    cy: 28.7307,
    rx: 6.62069,
    ry: 6.76923,
    fill: "#E57200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_515_1347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1739 30.7399L26.1739 32.0891C26.1739 32.1846 26.1177 32.2709 26.0317 32.3083C25.9461 32.3455 25.8458 32.3268 25.7791 32.2598L23.1411 29.642C23.0958 29.5973 23.0703 29.5357 23.0703 29.4713C23.0703 29.4069 23.0958 29.3453 23.1411 29.3006L25.7791 26.6828C25.8464 26.6161 25.9464 26.5974 26.0317 26.6342C26.1177 26.6717 26.1739 26.758 26.1739 26.8535L26.1739 28.2021L26.6139 28.2021C28.0527 28.2021 29.3792 27.4024 30.0753 26.1167L30.0818 26.1046C30.1234 26.0272 30.2023 25.9809 30.286 25.9809C30.3053 25.9809 30.3245 25.9831 30.3438 25.9882C30.4468 26.0152 30.5188 26.11 30.5188 26.2189C30.5188 28.6856 28.5769 30.6974 26.1739 30.7399Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_515_1347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.4485,
    height: 7.61541,
    fill: "white",
    transform: "matrix(1 -1.86676e-07 -4.09422e-08 -1 23.0703 32.9614)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedRefillIcon);
export default __webpack_public_path__ + "static/media/MedRefillIcon.91a97f81387a1a5700eace5832b61534.svg";
export { ForwardRef as ReactComponent };